/**
 * Jeton de commande du client (parcours QR code, sans compte).
 *
 * À la création de sa commande, le client reçoit un jeton propre à CETTE commande
 * (sessionStorage "client".access_token). Le serveur l'exige désormais pour
 * modifier la commande (ajout/retrait de plats, validation, coordonnées,
 * adresse de livraison) et pour la relire avec ses coordonnées (sans jeton,
 * le suivi par référence reste possible mais sans données personnelles).
 * Cet intercepteur l'ajoute automatiquement à ces appels quand aucun autre
 * jeton (équipe du restaurant) n'est déjà fourni.
 */
import axios from "axios";

const ROUTES_COMMANDE_CLIENT = /\/api\/(commandes?\/|detailscmd\/|rmdetailscmd\/|adresse)/;

const jetonClient = () => {
  try {
    return JSON.parse(sessionStorage.getItem("client"))?.access_token || null;
  } catch {
    return null;
  }
};

axios.interceptors.request.use((config) => {
  const dejaAuthentifie = config.headers?.Authorization || config.headers?.authorization;
  if (!dejaAuthentifie && ROUTES_COMMANDE_CLIENT.test(config.url || "")) {
    const jeton = jetonClient();
    if (jeton) {
      config.headers.Authorization = `Bearer ${jeton}`;
    }
  }
  return config;
});
